/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_SaveInputs */

const en_us2_workout_quick_save = /** @type {(inputs: Workout_Quick_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save workout`)
};

const pt_br2_workout_quick_save = /** @type {(inputs: Workout_Quick_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar treino`)
};

const es_419_workout_quick_save = /** @type {(inputs: Workout_Quick_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar entrenamiento`)
};

const pt_pt2_workout_quick_save = /** @type {(inputs: Workout_Quick_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar treino`)
};

const fr_fr2_workout_quick_save = /** @type {(inputs: Workout_Quick_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer la séance`)
};

const de_de2_workout_quick_save = /** @type {(inputs: Workout_Quick_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training speichern`)
};

const it_it2_workout_quick_save = /** @type {(inputs: Workout_Quick_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva allenamento`)
};

/**
* | output |
* | --- |
* | "Save workout" |
*
* @param {Workout_Quick_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_save = /** @type {((inputs?: Workout_Quick_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_save(inputs)
	if (locale === "es-419") return es_419_workout_quick_save(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_save(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_save(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_save(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_save(inputs)
	return en_us2_workout_quick_save(inputs)
});
export { workout_quick_save as "workout-quick.save" }